const element = document.getElementById('read-more');
let textToggle = false;
if(element){
  element.addEventListener('click', function(){
    document.getElementById('prod_desc').classList.toggle('expanded');
    if(textToggle == false){
      this.innerText = "READ LESS...";
      textToggle = true;
    }else{
      this.innerText = "READ MORE...";
      textToggle = false;
    }
  });
}